/* eslint-disable*/
import { replace } from 'lodash';
import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number: string | number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number: string | number) {
  return numeral(number).format('0.0 b');
}

export function fTimeFromSeconds(number: string | number) {
  const num = Number(number);
  var timeD = Math.floor(num / (24 * 60 * 60));
  var timeH = Math.floor(num % (24 * 60 * 60) / (60 * 60));
  var timeM = Math.floor(num % (24 * 60 * 60) % (60 * 60) / 60);
  var timeS = num % (24 * 60 * 60) % (60 * 60) % 60;
  var timeDMS = (timeD == 0 ? "" : timeD + '日') + (timeH == 0 ? "" : timeH + '時間') + (timeM == 0 ? "" : timeM + '分') + timeS + '秒';
  return timeDMS;
}
/* eslint-disable*/
